// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ubi8c","buttons":"styles_buttons__2rMvd"};